import { DirectSalesFilterScope } from 'components/common/types/DirectSalesCampaign.types';
import { TagInclude } from 'components/common/types/Deal.types';
import {
  DirectSalesProductFilter,
  ProductTemplateRulesResponse,
} from 'components/common/types/DirectSalesProductTemplate.types';
import { ProductManagement, SelectionPermission } from 'store/productManagement/reducer.types';

const isTagFilter = (item: unknown): item is DirectSalesProductFilter =>
  typeof item === 'object' &&
  item !== null &&
  'type' in item &&
  (item as DirectSalesProductFilter).type === 'TagFilter';

const isTagFilterArray = (
  fixedSet: ProductTemplateRulesResponse['fixedSet'],
): fixedSet is DirectSalesProductFilter[] => {
  if (!Array.isArray(fixedSet) || fixedSet.length === 0) {
    return false;
  }

  return [...fixedSet].every(isTagFilter);
};

const transformTagsValue = (tagsRule: ProductTemplateRulesResponse): TagInclude[] | undefined => {
  if (tagsRule.behaviour !== 'FIXED' || !tagsRule.fixedSet) {
    return undefined;
  }

  if (!isTagFilterArray(tagsRule.fixedSet)) {
    return undefined;
  }

  return tagsRule.fixedSet.map(({ id, name, selectionType, groupName }) => ({
    code: id,
    name,
    include: selectionType === DirectSalesFilterScope.INCLUDE,
    category: groupName ?? '',
  }));
};

export const transformTagsFromResponse = (
  tagsRule: ProductTemplateRulesResponse,
  tagsPermission: SelectionPermission,
): ProductManagement['newProduct']['tags'] => {
  if (tagsPermission === SelectionPermission.DISABLED) {
    return undefined;
  }

  if (tagsPermission === SelectionPermission.ALL_OPTIONS) {
    return { selectionPermission: tagsPermission };
  }

  const tagsValue = transformTagsValue(tagsRule);

  if (!tagsValue?.length) {
    return { selectionPermission: tagsPermission };
  }

  return { selectionPermission: tagsPermission, value: tagsValue };
};
